'use client'

import { createContext, useContext } from 'react'

import { VariantContextValuesType } from '../types'

export const BabyPDPVariantContext = createContext<VariantContextValuesType | undefined>(undefined)

export function useBabyPDPVariantContextValues(): VariantContextValuesType {
    const context = useContext(BabyPDPVariantContext)
    if (context === undefined) {
        throw new Error('useBabyPDPVariantContext must be used within a BabyPDPVariantProvider')
    }
    return context
}
